import {useLocation} from "react-router";

export const usePathname = () => {
    const { pathname } = useLocation();

    const isHomepage = pathname === '/'
    const isLoginPage = pathname === "/login";
    const isSupportPage = pathname === "/support";
    const isFAQPage = pathname === "/faq";

    return {
        isHomepage,
        isLoginPage,
        isSupportPage,
        isFAQPage
    };
}